module.exports = __webpack_public_path__ + "media/sounds/tap_04-638c3352f0c6f8fc3a1b56b6fe9e4724.wav";